// Direct import to avoid pulling in the component tree via the barrel (which triggers store/localStorage)
import { formValueToMagicLink } from 'pages/MasterAdmin/CommunityWizard/AdvancedSettingsTab/utils';

// The form stores magicLinkAuthEnabled as a string ('default'|'enabled'|'disabled')
// for RadioGroup compatibility. Convert to boolean|null for the API.
// If the value is already boolean|null (non-form callers), leave it untouched.
const convertMagicLinkAuthEnabled = (settings: Record<string, unknown>): Record<string, unknown> => {
  const { magicLinkAuthEnabled } = settings;
  if (typeof magicLinkAuthEnabled !== 'string') return settings;

  return {
    ...settings,
    magicLinkAuthEnabled: formValueToMagicLink(magicLinkAuthEnabled),
  };
};

export const mapCommunityToApi = (data: object) => {
  const { communitySettings, ...rest } = data as Record<string, unknown>;

  return {
    ...rest,
    ...(communitySettings
      ? { communitySettings: convertMagicLinkAuthEnabled(communitySettings as Record<string, unknown>) }
      : {}),
    // TODO remove after its no longer required by backend
    calendarPermissionsRequired: false,
  };
};
